module.exports = __webpack_public_path__ + "static/img/eqlogo.656e501.png";


//////////////////
// WEBPACK FOOTER
// ./src/eqplay/imgs/eqlogo.png
// module id = qUvz
// module chunks = 1